import PropTypes from 'prop-types'

import { Value } from 'components/attacks/details/AttackStyles'
import {
  getAttackStageColor,
  getAttackStageReadable
} from 'components/attacks/utils/attack-stages'
import {
  getK8AttackStageColor,
  isKubernetesStage
} from 'components/attacks/utils/kubernetes'

const Stage = ({ stage, error, ...rest }) => {
  const hasKubernetesStage = isKubernetesStage(stage)
  return (
    <Value
      css={{
        color: hasKubernetesStage
          ? getK8AttackStageColor(stage)
          : getAttackStageColor(stage)
      }}
      {...rest}
    >
      {getAttackStageReadable(stage, error)}
    </Value>
  )
}

Stage.propTypes = {
  stage: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string
}

export default Stage
